import { useEffect, useState } from "react";
import api from "@/lib/api";
import DashboardShell from "@/components/nav/DashboardShell";
import { Check, X, Edit3, Eye } from "lucide-react";
import { toast } from "sonner";

export default function Approvals() {
  const [items, setItems] = useState([]);
  const [expanded, setExpanded] = useState(null);
  const [editText, setEditText] = useState("");
  const [filter, setFilter] = useState("pending");

  const load = () => api.get(`/approvals?status=${filter}`).then(({data}) => setItems(data)).catch(() => {});
  useEffect(() => { load(); }, [filter]);

  const decide = async (id, decision, edited_summary) => {
    try {
      await api.post(`/approvals/${id}/decide`, { decision, edited_summary });
      toast.success(`Approval ${decision}d`);
      setExpanded(null);
      load();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed");
    }
  };

  return (
    <DashboardShell>
      <div className="brand-eyebrow mb-4">HUMAN IN THE LOOP</div>
      <h1 className="brand-headline text-4xl md:text-6xl mb-8">Approvals.</h1>

      <div className="flex gap-2 mb-6">
        {["pending", "approved", "rejected", "edited", "all"].map(s => (
          <button key={s} data-testid={`approvals-filter-${s}`} onClick={() => setFilter(s)}
            className={`text-[10px] tracking-widest font-bold px-3 py-1.5 border ${filter===s ? "bg-gold text-ink border-gold" : "text-smoke border-line hover:border-gold"}`}>{s.toUpperCase()}</button>
        ))}
      </div>

      <div className="space-y-4">
        {items.length === 0 && <div className="border border-line p-10 text-smoke text-sm text-center">Nothing in this filter.</div>}
        {items.map(ap => (
          <div key={ap.id} className="card-white p-8">
            <div className="flex items-start justify-between gap-4 flex-wrap">
              <div className="flex-1 min-w-0">
                <div className="brand-eyebrow" style={{color:'#0B0D10'}}>{(ap.ai_employee_slug || "employee").toUpperCase()} · {ap.action_type}</div>
                <div className="mt-3 text-ink font-semibold">{ap.reason}</div>
                <div className="mt-4 text-ink/80 text-sm whitespace-pre-wrap max-h-64 overflow-auto">
                  {expanded === ap.id && editText !== null ? (
                    <textarea rows={10} value={editText} onChange={e => setEditText(e.target.value)}
                      style={{background:'#FFFFFF', color:'#0B0D10', border:'1px solid #d4d4d4'}} />
                  ) : ap.summary}
                </div>
                <div className="mt-3 text-ink/50 text-[11px]">Created {new Date(ap.created_at).toLocaleString()}</div>
              </div>
              {ap.status === "pending" ? (
                <div className="flex gap-2 flex-wrap">
                  {expanded === ap.id ? (
                    <>
                      <button data-testid={`ap-save-${ap.id}`} onClick={() => decide(ap.id, "edit", editText)} className="bg-ink text-white px-4 py-2 text-xs font-bold">Save & Approve</button>
                      <button onClick={() => { setExpanded(null); setEditText(""); }} className="border border-ink text-ink px-4 py-2 text-xs font-bold">Cancel</button>
                    </>
                  ) : (
                    <>
                      <button data-testid={`ap-view-${ap.id}`} onClick={() => { setExpanded(ap.id); setEditText(ap.summary); }} className="border border-ink text-ink px-4 py-2 text-xs font-bold inline-flex items-center gap-2"><Edit3 size={14} /> Edit</button>
                      <button data-testid={`ap-approve-${ap.id}`} onClick={() => decide(ap.id, "approve")} className="bg-ink text-white px-4 py-2 text-xs font-bold inline-flex items-center gap-2"><Check size={14} /> Approve</button>
                      <button data-testid={`ap-reject-${ap.id}`} onClick={() => decide(ap.id, "reject")} className="border border-ink text-ink px-4 py-2 text-xs font-bold inline-flex items-center gap-2"><X size={14} /> Reject</button>
                    </>
                  )}
                </div>
              ) : (
                <div className="text-[10px] tracking-widest font-bold text-ink/60">{ap.status.toUpperCase()}</div>
              )}
            </div>
          </div>
        ))}
      </div>
    </DashboardShell>
  );
}
